import Config from './config'
import AppEvents from './appevents'
import { Enum } from '@/helpers/enum'

export const DataStateKind = {
  notInitiated: Symbol(0),
  loading: Symbol(1),
  loaded: Symbol(2),
  error: Symbol(3),
  cancelled: Symbol(4)
}

export const AppKind = new Enum({
  Litzscore: 'litzscore',
  Workflow: 'workflow'
})

export class DataState {
  constructor (state) {
    this.state = state
    this.ref = null
    this.msg = null
  }

  isLoading () {
    return this.state === DataStateKind.loading
  }

  isLoaded () {
    return this.state === DataStateKind.loaded
  }

  isLoadedOrNotInit () {
    return this.isLoaded() || (this.state === DataStateKind.notInitiated)
  }

  isNotInit () {
    return (this.state === DataStateKind.notInitiated)
  }

  isError () {
    return this.state === DataStateKind.error
  }

  changeToLoading () {
    this.state = DataStateKind.loading
  }

  changeToLoaded () {
    this.state = DataStateKind.loaded
  }

  changeToError (msg) {
    this.state = DataStateKind.error
    this.msg = msg
  }

  static newLoading () {
    return new DataState(DataStateKind.loading)
  }

  static newNotInit () {
    return new DataState(DataStateKind.notInitiated)
  }
}

export const AppState = {
  // Based on https://vuejs.org/v2/guide/state-management.html#Simple-State-Management-from-Scratch

  instance: {
    user: {},
    userLoggedIn: false,
    pageTitle: '',
    activePage: 'home',
    breadcrumb: [],
    appClass: '',
    appTheme: Config.ThemeName || 'dark',
    fantasy: {
      showEdit: false,
      team: null
    },
    hangDailog: {
      show: false,
      position: 'on-left',
      holderData: { 'key': null }
    },
    appKind: null,
    numberGoodBadClass (x, y) {
      return {
        'nothing': y === undefined || y === null,
        'zero': y === 0,
        'natural': x === y,
        'good': x < y,
        'bad': x > y
      }
    }
  },
  updateUserLoggedIn (status) {
    this.instance.userLoggedIn = status
  },
  updateAppKind (kind) {
    this.instance.appKind = kind
  },
  updateTitles (docTitle, pageTitle) {
    if (docTitle === Config.title) {
      document.title = docTitle
    } else {
      document.title = `${docTitle} | ${Config.title}`
    }
    if (pageTitle) {
      this.instance.pageTitle = pageTitle
    } else {
      this.instance.pageTitle = docTitle
    }
  },
  updateActivePage (pageKey) {
    this.instance.activePage = pageKey
  },
  updateBreadcrumb (items) {
    this.instance.breadcrumb = items
  },
  updateSelectedPlayer (player) {
    this.instance.cricket.selectedPlayer = player
  },
  resetBreadcrumb () {
    this.instance.breadcrumb = []
  },
  updateAppClass (newClass) {
    this.instance.appClass = newClass
  },

  updateAppTheme (newTheme) {
    this.instance.appTheme = newTheme
    document.body.className = 'app-theme-' + AppState.instance.appTheme
  },

  resetAppTheme () {
    this.updateAppTheme(Config.ThemeName || 'dark')
  },

  showFantasyCreateTeam (selector, vueInstance) {
    this.instance.fantasy.team = selector
    this.instance.fantasy.showEdit = true

    if (vueInstance) {
      vueInstance.$globalEvents.$emit(AppEvents.fantasyCreateTeamVisible, selector)
    }
  },

  hideFantasyCreateTeam (vueInstance) {
    this.instance.fantasy.team = null
    this.instance.fantasy.showEdit = false
    if (vueInstance) {
      vueInstance.$globalEvents.$emit(AppEvents.fantasyCreateTeamHidden, this.instance.fantasy.team)
    }
  },

  showHangDailog (position, holderKey) {
    this.instance.hangDailog.show = true
    if (position) {
      this.instance.hangDailog.position = position
    }

    if (holderKey) {
      this.instance.hangDailog.holderData.key = holderKey
    }
  },

  hideHangDailog () {
    this.instance.hangDailog.show = false
    this.instance.hangDailog.holderData.key = null
  }
}

export const WizardManager = {
  flow: [],
  currentFlowIndex: 0,
  stateData: {},
  ChildWizard: {
    flow: [],
    currentFlowIndex: 0,
    stateData: {}
  },

  createWizard (section, payload) {
    const found = WizardManager.flow.some(e1 => e1.key === section.key)
    if (!found) {
      let newSection = {
        'key': section.key,
        'value': section.value
      }
      newSection['is' + section.key] = section['is' + section.key]
      WizardManager.flow.push(newSection)
      WizardManager.stateData = payload
      WizardManager.currentFlowIndex = WizardManager.flow.length - 1
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
      console.log('WizardManager', WizardManager)
    }
  }
}
